
    import {defineComponent, h, reactive, nextTick} from 'vue'
    import {useRoute} from "vue-router";
    import  reportMsgUt from "@/util/reportMsg";
    import {useStore} from '@/store';
    import { Toast } from 'scvant';
    import {GetReportViewModelFromJSON, GetReportViewModelFromServe, GetVerifyEffectiveReport, GetOldReportPdfUrl, GetCheKuangReportUrl} from '@/service'

    let nameList = [
        'navigation',
        'HeadTip',
        'CarNameVin',
        'SwiperBanner',
        'BaseInfo',
        'ConfigurationInfo',
        'Entrust',
        'CheckCont',
        'entrustQuery',
        'EcuCheck',
        'RemarksMsg',
        'detectMsg',
        'EnsureService',
        'ReminderText',
    ]
    let list: any[] = [];
    let components = {};
    nameList.forEach(item => {
        if (!components[item]) {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const model = require(`./_components/${item}.vue`)['default'];
            list.push(model)
            components[item] = model
        } else {
            list.push(components[item])
        }
    });
    interface State {
        reportMsg: object;
    }
    export default defineComponent({
        name: "h5_index",
        components,
        setup() {
            let state: State = reactive({
                reportMsg: {}
            })
            state.reportMsg = reportMsgUt;
            document.title= "检测认证评估报告";
            const {query} = useRoute();
            const {reportCode, templateCode} = query;
            let store = useStore()
            // let time = 0;
            // if (reportCode && typeof reportCode === 'string') {
            //     time = Number(reportCode.substring(2));
            // }
            // const batTime = 230525183151001;
            Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '加载中...',
            });
            // if (time<batTime) {
            //     GetReportViewModelFromServe({reportCode, templateCode, reportVersion: 'tocv002'}).then((res: any) => {
            //         store.dispatch('saveDataInfo', res)
            //         Toast.clear();
            //         nextTick(() => {
            //             window.scrollTo(0, store.state.pageScrollTop)
            //             store.dispatch('savePageScrollTop', 0);
            //         });
            //     }).catch((err) => {
            //         console.error(err)
            //     })
            // } else {
            GetReportViewModelFromJSON({reportCode, reportVersion: 'tocv002', templateCode}).then((res: any) => {
                store.dispatch('saveDataInfo', res)
                Toast.clear();
                nextTick(() => {
                    window.scrollTo(0, store.state.pageScrollTop)
                    store.dispatch('savePageScrollTop', 0);
                });
            }).catch((err) => {
                if (err.message.indexOf('404')) {
                    // json文件404了请求直连接口
                    Toast.loading({
                        duration: 0,
                        forbidClick: true,
                        message: '加载中...',
                    });
                    GetReportViewModelFromServe({reportCode, templateCode, reportVersion: 'tocv002'}).then((res: any) => {
                        store.dispatch('saveDataInfo', res)
                        Toast.clear();
                        nextTick(() => {
                            window.scrollTo(0, store.state.pageScrollTop)
                            store.dispatch('savePageScrollTop', 0);
                        });
                    }).catch((err) => {
                        console.error(err)
                    })
                } else {
                    console.error(err)
                }
            })
            // }
            // 直链接口
            // GetReportViewModelFromServe({reportCode, templateCode}).then((res: any) => {
            //     store.dispatch('saveDataInfo', res)
            // }).catch((err) => {
            //     // eslint-disable-next-line
            //     console.error(err)
            // })
            // 先尝试json文件
            
            
            return {
                state
            }
        },
        render() {
            let className='';
            if (this.state.reportMsg['RpZB']()) {
                className = 'main__bg_color1';
            } else if (this.state.reportMsg['RpCK']()) {
                className = '';
            } else {
                className = 'toc_main__bg_color';
            }
            return h('div', {class: className}, list.map((item, index) =>
                h(item, {}, index)
            ));
        },
        beforeRouteEnter(to, from, next) {
            const {reportCode, reportVersion,templateCode} = to.query;
            let time = 0;
            if (reportCode && typeof reportCode === 'string') {
                time = Number(reportCode.substring(2));
            }
            const batTime = 230525183151001;
            function jumpToChekuang() {
                if (!templateCode) {
                    to.query.templateCode = 'no_cert_report';
                }
                if(`${reportCode}`.indexOf('DE') > -1) {
                    let url = '';
                    GetCheKuangReportUrl({reportCode, templateCode}).then((res: any) => {
                        url = res;
                        if (url) {
                            window.location.href = url;
                        } else {
                            next();
                        }
                    }).catch(() => {
                        next();
                    });
                } else {
                    next();
                }
            }
            function jump() {
                if (reportVersion && reportVersion === 'tocv003') {
                    next({
                        path: '/tocV3',
                        query: to.query
                    })
                }
                if (reportVersion && reportVersion === 'tocv004') {
                    next({
                        path: '/tocV4',
                        query: to.query
                    })
                }
                if (!templateCode) {
                    to.query.templateCode = 'no_cert_report';
                }
                
                if(`${reportCode}`.indexOf('DE') > -1) {
                    let isClose = true;
                    GetVerifyEffectiveReport({reportCode}).then((res: any) => {
                        isClose = res;
                        if (!isClose) {
                            next('/deffectiveReport')
                        } else {
                            jumpToChekuang();
                        }
                    }).catch(() => {
                        next();
                    });
                } else {
                    next();
                }
            }
            if (time<batTime) {
                console.log('cccccccccc');
                let opt = {
                    reportCode,
                    reportVersion,
                    templateCode
                };
                GetOldReportPdfUrl(opt).then((res: any) => {
                    if (res) {
                        next({
                            path: '/viewPDF',
                            query: {
                                'pdfurl': encodeURIComponent(res)
                            }
                        })
                    } else {
                        jump();
                    }
                });
            } else {
                jump();
            }
            
        }
    });
